import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import ar from "./ar.json";

i18n.use(initReactI18next).init({
	resources: {
		en: { translations: en },
		ar: { translations: ar }
	},
	// Default language; the app overrides this on mount from the persisted
	// preference (see App.js). Arabic-first since this is the alshorja.com admin.
	lng: "ar",
	fallbackLng: "en",
	debug: false,
	ns: ["translations"],
	defaultNS: "translations",
	keySeparator: false,
	interpolation: {
		escapeValue: false,
		formatSeparator: ","
	},
	react: {
		useSuspense: false
	}
});

export default i18n;
